<template>
  <v-container fluid fill-height class="pa-0 ma-0 white" id="profile">
    <v-layout column class="pa-0 ma-0">
      <v-card-text>
        <h2 style="margin: 0% auto;"><b>Feedback</b></h2>
      </v-card-text>

      <v-card-text class="pa-0 margin-title">
        
        <v-card v-if="feedbackNama">
          <feedback-list></feedback-list>
        </v-card>

        <v-card v-else>
          <feedback-list-two></feedback-list-two>
        </v-card>

      </v-card-text>

    </v-layout>
  </v-container>     
</template>

<script>
import { getUserById } from '@/api/user';

import VWidget from '@/components/VWidget';
import FeedbackList from '@/components/feedback/FeedbackList'
import FeedbackListTwo from '@/components/feedback/FeedbackListTwo'
import TambahkanFeedback from '@/components/feedback/TambahkanFeedback'
export default {
  components: {
    VWidget,
    FeedbackList,
    FeedbackListTwo,
    TambahkanFeedback,
  },
  data () {
    return {
      chat: null,
      selectedTab: null,
      status: false,
      feedbackNama: localStorage.feedbackNama
    };
  },
  computed: {
   
    user () {
      let Origin = {
        name: 'Feedback',
        avatar: '',
      };
      let user = getUserById(this.$route.params.uuid);
      return Object.assign(Origin, user);
    }    
  },
};
</script>